module.exports = __webpack_public_path__ + "static/26th-dddfb39c281fd8655a79788b31939a6a.gif";